function t() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
export {
  t as isPlatformMac
};
//# sourceMappingURL=platformUtil.mjs.map
